interface VariantConditions {
  priceBeforeCurrentSale?: number;
  priceBeforeCurrentSaleIncVAT?: number;
  isOnClearance?: boolean;
  isRedemptionOffer?: boolean;
}

// Returns the badge variant that corresponds to the met conditions. Ordered by marketing priority.
const getBadgeVariant = ({
  priceBeforeCurrentSale,
  priceBeforeCurrentSaleIncVAT,
  isOnClearance,
  isRedemptionOffer,
}: VariantConditions) => {
  if (priceBeforeCurrentSale && priceBeforeCurrentSaleIncVAT)
    return 'priceDrop';
  if (isOnClearance) return 'clearance';
  if (isRedemptionOffer) return 'redemption';

  return undefined;
};

export default getBadgeVariant;
